module.exports = __webpack_public_path__ + "static/media/hearclearpro-earwax-guard-2.8ff146f1.png";